import { defineComponent as _defineComponent } from 'vue'
import {ref, computed, onMounted, onUnmounted} from 'vue';
import SvgIcon from '../common/SvgIcon.vue';
import defaultAvatar from '@/assets/img/avatar.png';
import {ICON_NAME} from '../../../constants/icon';
import TUIRoomCore,{ETUIRoomEvents, RoomInfo} from "@/TUIRoom/tui-room-core";

interface Props {
  userId: string,
  userName: string,
  userRole?: string,
  userAvatar?: string,
  roomInfos?: RoomInfo,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UserInfo',
  props: {
    userId: null,
    userName: null,
    userRole: null,
    userAvatar: null,
    roomInfos: null
  },
  emits: ['log-out'],
  setup(__props: any) {

const props = __props as {
  userId: string,
  userName: string,
  userRole?: string,
  userAvatar?: string,
  roomInfos?: RoomInfo,
}



console.log("userInfo----------------------------------------")

const userInfoRef = ref();
const showUserControl = ref(false);
let hotScores =  ref(props.roomInfos?.hotScores);
const iconName = computed(() => (showUserControl.value ? ICON_NAME.LineArrowUp : ICON_NAME.LineArrowDown));

function handleUserControl() {
  // showUserControl.value = !showUserControl.value;
}

function hideUserControl(event: Event) {
  if (!userInfoRef.value.contains(event.target)) {
    showUserControl.value = false;
  }
}

const onRoonHeatNotification = async (data: any) => {
    console.log("收到热度通知消息------------------------------------------")
    //{"groupId":"207","msgContent":{"hotScores":10,"online":18,"roomNo":"207"},"msgKey":"207","msgType":"msg_hot_online"}
    let resData = JSON.parse(data);
    console.log(data);
    hotScores.value = resData.msgContent.hotScores;
}


onMounted(async () => {
  TUIRoomCore.on(ETUIRoomEvents.onRoonHeatNotification, onRoonHeatNotification);
 
  window.addEventListener('click', hideUserControl);
});

onUnmounted(() => {
  TUIRoomCore.off(ETUIRoomEvents.onRoonHeatNotification, onRoonHeatNotification);

  window.removeEventListener('click', hideUserControl);
});

return { __sfc: true,props, userInfoRef, showUserControl, hotScores, iconName, handleUserControl, hideUserControl, onRoonHeatNotification, defaultAvatar }
}

})